import { useMutation } from '@tanstack/react-query'
import { axios } from 'Lib/axios'
import { AxiosError } from 'axios'
import { queryClient } from 'Lib/react-query'
import { useUserStore } from 'Stores/userStoreModuleFed'
import { UploadFile } from '@clickcease/cc-client-components-lib/dist/types/Files'

interface ApiResponse {
  httpStatusCode: number
  timestamp: string
  result: string
  message?: string
  path: string
}

const setAccountLogo = async (file: UploadFile): Promise<ApiResponse> => {
  const accountId = useUserStore.getState().accountId

  try {
    const response = await axios.put<ApiResponse>(
      `accounts/${accountId}/setup/logo`,
      { file },
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    )
    return response.data
  } catch (error) {
    if (error instanceof AxiosError && error.response) {
      return error.response.data as ApiResponse
    }
    throw error
  }
}

export const useSetAccountLogo = () =>
  useMutation(setAccountLogo, {
    onSuccess: () => {
      void queryClient.removeQueries(['accountLogo'])
    },
  })
